export enum TaxParamNfseIssuerEnum {
    TECNOSPEED = 'TECNOSPEED',
    NACIONAL = 'NACIONAL',
}

export enum TaxParamStreetTypeEnum {
    ALAMEDA = 'Alameda',
    AVENIDA = 'Avenida',
    CHACARA = 'Chácara',
    COLONIA = 'Colônia',
    CONDOMINIO = 'Condomínio',
    ESTANCIA = 'Estância',
    ESTRADA = 'Estrada',
    FAZENDA = 'Fazenda',
    PRACA = 'Praça',
    PROLONGAMENTO = 'Prolongamento',
    RODOVIA = 'Rodovia',
    RUA = 'Rua',
    SITIO = 'Sítio',
    TRAVESSA = 'Travessa',
    VICINAL = 'Vicinal',
}
